import React from 'react';
import { Nodata } from '../../utils/Icons';

const NoData = () => {
    return (
        <img src={Nodata} alt="noData" />
    )
}

export default NoData;